var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{class:("country-" + (_vm.props.country)),on:{"mouseover":function($event){return _vm.props.tooltipCallback({ text: _vm.props.tooltip, event: $event })}}})}
var staticRenderFns = []

export { render, staticRenderFns }